<div class="row mt-n1">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Listado de Solicitudes de Campaña
            </div>
    
            <div class="card-body-grid" *ngIf="result">
    
                <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true"
                    [lazyLoadOnInit]="false" [rowHover]="true"  [selectionMode]="'none'"
                    dataKey="Id"
                    (onLazyLoad)="onSearchLazy($event)" [paginator]="true" [columns]="cols"
                    [rows]="result?.PageSize" sortOrder="0" 
                    [totalRecords]="result?.TotalCount" [loading]="loading"
                    [ngClass]="displayGridHidden(result.ResultList)"
                    styleClass="table table-responsive-sm table-striped table-sm">
    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th nowrap scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}"
                                [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
    
                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [ngClass]="{ 'td-xs': col.reduce }">
                                <span *ngIf="col.field==='Image'">
                                    <img class="estado-icono" src="{{ rowData['IdEstadoSolicitudCam'] | IconoEstadoSolicitudCam }}" container="body" ngbTooltip="{{ rowData['EstadoSolicitudCam'] }}" />
                                </span>
                                <span *ngIf="col.field!=='Link' && col.field !== 'FechaCreacion' && col.field !== 'FechaSolicitud'">
                                    {{rowData[col.field]}}
                                </span>
                                <span *ngIf="col.field === 'FechaCreacion' || col.field === 'FechaSolicitud'">
                                    {{rowData[col.field] | date:'dd/MM/yyyy HH:mm'}}
                                </span>
                                <ng-container *ngIf="col.field === 'Link'" class="btn-group">
                                    <ng-container *ngIf="hasWriteAccess(rowData) && !hasPeriodoFinalizado(rowData)">
                                        <button (click)="onEdit(rowData)" type="button" class="btn btn-sm btn-warning" title="Editar">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="(hasViewAccess(rowData) && !hasWriteAccess(rowData)) || hasPeriodoFinalizado(rowData)">
                                        <button (click)="onView(rowData)" type="button" class="btn btn-sm btn-info" title="Consultar">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="hasDeleteAccess(rowData)">
                                        <button (click)="onDelete(rowData)" type="button" class="btn btn-sm btn-danger" title="Eliminar">
                                            <span class="fa fa-remove"></span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                    
                <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
            </div>
    
        </div>
    </div>
</div>
